import { programs } from '../../../mocks/programs';
import { Link } from 'react-router-dom';

export default function Programs() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 2026 Key Dates & What's Included Box */}
        <div className="mb-16 bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-display text-3xl text-warrior-black mb-4">2026 KEY DATES</h3>
              <div className="space-y-3 font-sans text-sm text-gray-700">
                {[
                  { date: 'March 1', label: 'Football & Sideline Cheer Registration Opens' },
                  { date: 'March 15', label: 'Competition Cheer Registration Opens' },
                  { date: 'March 19', label: 'Chick-fil-A Spirit Night Fundraiser (4:00pm–8:00pm)' },
                  { date: 'April 22', label: 'Your Pie Spirit Night Fundraiser (11:00am–9:00pm)' },
                  { date: 'May 31', label: 'Last Day to Register for Cheer' },
                  { date: 'June 1–3', label: "Varsity Head Coach Holley's Youth Football Camp" },
                  { date: 'June 15–17', label: "Lil' Warrior Cheer Camp" },
                  { date: 'June 30', label: 'Last Day to Register for Football' },
                  { date: 'August 8', label: 'CFL Jamborees' },
                  { date: 'August 15', label: 'CFL County Scrimmage Games' },
                  { date: 'August 22', label: 'CFL Opening Week' },
                  { date: 'Sept 21–25', label: 'Fall Break (Cobb, Cherokee, Fulton, Paulding, Marietta)' },
                  { date: 'November 7', label: '1st Week of Playoffs' },
                  { date: 'November 14', label: '2nd Week of Playoffs' },
                  { date: 'November 21', label: 'Super Bowl & All-Star 2026' },
                ].map((item) => (
                  <div key={item.date} className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-calendar-check-line text-base text-warrior-red"></i>
                    </div>
                    <div>
                      <strong className="text-warrior-black">{item.date}:</strong> {item.label}
                      {item.date === 'Sept 21–25' && (
                        <ul className="mt-1.5 ml-1 space-y-1 text-xs text-gray-600 list-none">
                          <li className="flex items-start space-x-2">
                            <span className="text-warrior-red mt-0.5">✓</span>
                            <span>We <strong>WILL</strong> have a game the Saturday going into Fall Break.</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-warrior-red mt-0.5">✗</span>
                            <span>We <strong>WILL NOT</strong> have a game the Saturday coming back from Fall Break.</span>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-display text-3xl text-warrior-black mb-4">WHAT'S INCLUDED</h3>
              <div className="space-y-4 font-sans text-base text-gray-700">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Cheer uniform, football jersey, and equipment usage&nbsp;</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Games held in high school football stadiums</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Coaching from experienced staff</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>8 regular season games plus playoffs</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Team photos and end-of-season awards ceremony</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Youth Night at the Varsity Game: More information to come</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Youth Homecoming: More information to come</div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-xl text-warrior-red"></i>
                  </div>
                  <div>Warm welcome to the Warrior Family</div>
                </div>
              </div>
            </div>
          </div>

          {/* Important Info */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h3 className="font-display text-3xl text-warrior-black mb-4">IMPORTANT INFO</h3>
            <div className="grid sm:grid-cols-2 gap-3 font-sans text-sm text-gray-700">
              {[
                'We WILL have a game the Saturday going into Fall Break.',
                'We WILL NOT have a game the weekend coming out of Fall Break.',
                'Football equipment & cheer uniform fittings will be held in March, April, and May. Exact dates to be confirmed.',
                'If you have multiple children signing up, use code FAMILY at registration for $25 off.',
                'Payment plan is available, details are in the registration portal.',
              ].map((item) => (
                <div key={item} className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-base text-warrior-red"></i>
                  </div>
                  <div>{item}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Anchor target for Programs nav link */}
        <div id="programs" className="relative -top-24 invisible h-0"></div>

        <div className="text-center mb-16">
          <h2 className="font-display text-5xl sm:text-6xl text-warrior-black mb-4">
            Be a warrior.
          </h2>
          <p className="font-sans text-lg text-gray-600 max-w-2xl mx-auto">
            Cherokee Youth Football & Cheer offers comprehensive programs designed to develop young athletes in Canton, GA
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {programs.map((program) => (
            <Link
              key={program.id}
              to={program.link}
              className="group relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="relative w-full h-96">
                <img
                  src={program.image}
                  alt={program.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-warrior-red/40 group-hover:bg-warrior-red/50 transition-all duration-300"></div>
                
                {/* Icon */}
                <div className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className={`${program.icon} text-2xl text-white`}></i>
                </div>

                {/* Text Overlay */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                  <div className="bg-warrior-black/70 backdrop-blur-sm rounded-2xl px-8 py-6 transform group-hover:scale-105 transition-transform duration-300">
                    <h3 className="font-display text-4xl text-white mb-2">
                      {program.title}
                    </h3>
                    <p className="font-sans text-lg text-gray-200 mb-3">
                      {program.subtitle}
                    </p>
                    <div className="flex flex-wrap justify-center gap-2 mb-3">
                      {program.gradeLevels.map((grade) => (
                        <span
                          key={grade}
                          className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm text-white font-sans"
                        >
                          {grade}
                        </span>
                      ))}
                    </div>
                    {/* Remove Head Coach line */}
                  </div>
                </div>
              </div>

              {/* Description on Hover */}
              <div className="absolute inset-x-0 bottom-0 bg-white p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <p className="font-sans text-sm text-gray-700 leading-relaxed">
                  {program.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}